import * as React from 'react';

export class LazyRef<T> implements React.RefObject<T> {
    delegate?: React.RefObject<T>;
    get current(): T | null {
        return this.delegate?.current || null;
    }
}
